import React, {FC} from 'react';
import {Box} from "@mui/material";
import {INavigateItem} from "@view/navigate/types";
import NavigateItemContent from "@view/navigate/item/NavigateItemContent";

interface IProps {
    navigate: INavigateItem,
}

const ItemNavigateLink: FC<IProps> = ({navigate}) => {
    return (
        <Box
            component={'a'}
            href={navigate.path}
            key={navigate.path}
        >
            <NavigateItemContent navigate={navigate}/>
        </Box>
    );
};

export default ItemNavigateLink;
